import axios from 'axios';
import Vue from 'vue';
import q from 'q';
import { Message } from 'element-ui';
import { isHL } from './utils'

import { localStorage } from './storage';
import { TOKEN } from './storageKeys';

function request(config, isFile) {
  let baseURL = process.env.VUE_APP_API_HOST
  if (isHL()) {
    console.log('isHL')
    baseURL = process.env.VUE_APP_API_HOST_HL
  }
  const headers = config.headers || {};
  delete config.headers;
  const _config = {
    baseURL,
    headers: {
      token: Vue.ls.get(TOKEN),//localStorage.getItem(TOKEN), // TOKEN被编译成 UNION_LOCAL_TOKEN
      ...headers,
    },
    ...config,
  };

  return q
    .resolve(
      axios(_config)
        .then((res) => {
          if (isFile) return res;
          if (res.status === 200) return res.data;
          throw new Error(`服务端错误，状态码: ${res.status}`);
        })
        .then((res) => {
          if (isFile) return res;
          if (!res || typeof res === 'string') {
            throw new Error('服务端错误');
          }

          switch (res.code) {
            case 1001: // 只针对dsp渠道是ToutiaoS的dsp广告位的校验包名
            case 200:
              return res;
            case 103: // 登录态失效/账号禁用/sso登录失败等
              localStorage.removeItem(TOKEN);
              setTimeout(() => {
                location.href = '/login';
              }, 2000);
              break;
          }

          throw new Error(res.message || '请求错误');
        }),
    )
    .catch((e) => {
      Message.error(e.message);
      return q.reject(e);
    });
}

export default request;
